import React, { useState } from "react";
import {Grid,  Box, Typography } from "@mui/material";

const ReadMore = (props) => {
    let { text, maxChars } = props;

    let readMoreText = "read more";
    let readLessText = "read less";
    const [isExpanded, setIsExpanded] = useState(false);
    const hasReadMore = text.length > maxChars;
    return (
        <Grid>
            {text && (isExpanded || !hasReadMore) && (
                <Box>
                    {text}{" "}
                    {hasReadMore && !!isExpanded && (
                        <Typography
                            onClick={() => setIsExpanded(false)}
                            sx={{
                                cursor: "pointer",
                                color: "#DB8829",
                                fontSize: "0.8rem",
                                fontWeight: "800",
                                "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                },
                            }}
                        >
                            {readLessText}
                        </Typography>
                    )}
                </Box>
            )}
            {text && !isExpanded && !!hasReadMore && (
                <Box>
                    {text.slice(0, maxChars)}...{" "}
                    <Typography
                        onClick={() => setIsExpanded(true)}
                        sx={{
                            cursor: "pointer",
                            color: "#DB8829",
                            fontSize: "0.8rem",
                            fontWeight: "800",
                            "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                            },
                        }}
                    >
                        {readMoreText}
                    </Typography>
                </Box>
            )}
        </Grid>
    );
};
export default ReadMore;  